/*
{"mas":{"emas":[{"maId":21,"periodLength":21,"price":91.36363636363636},{"maId":8,"periodLength":8,"price":78.16666666666667},{"maId":21,"periodLength":21,"price":91.36363636363636}]},"candle":{"firstCandleCandleDuration":1,"priceToBreak":99.0}}
*/
import PropTypes from 'prop-types';
import React from 'react';

export const EmaIntersectsFirstCandleWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'EMA_INTERSECTS_FIRST_CANDLE',
    category: 'Setup Filter',
    type: 'EMA Intersects First Candle',
    domain: 'Underlying',
  };
  const mas = softOrder.mas.emas; //each object in the array has an id, periodlength, and the price. this message will update VERY frequently
  const candle = softOrder.candle;
  const candleDuration = candle.firstCandleCandleDuration;
  const candlePriceToBreak = candle.priceToBreak;
  //following two fields occur if trade plan is go Long and go Short
  const candlePriceToBreakLong = candle['priceToBreak (long)']; //todo change backend to be priceToBreakLong
  const candlePriceToBreakShort = candle['priceToBreak (short)']; //todo change backend to be priceToBreakShort
  return (
    <Component
      details={details}
      mas={mas}
      candleDuration={candleDuration}
      priceToBreakLong={candlePriceToBreakLong}
      priceToBreakShort={candlePriceToBreakShort}
      priceToBreak={candlePriceToBreak}
      {...rest}
    />
  );
};

EmaIntersectsFirstCandleWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    candle: PropTypes.shape({
      firstCandleCandleDuration: PropTypes.any,
      priceToBreak: PropTypes.any
    }),
    mas: PropTypes.shape({
      emas: PropTypes.any
    })
  })
};

